<template>
  <div class="m-box">
    <van-form @submit="onSubmit">
      <div class="x-input-no x-bottom-15">
        <van-field v-model.trim="form.phone" type="tel" placeholder="请输入手机号" :rules="[{ required: true, message: '' }]">
          <template #right-icon>
            <span v-if="isCode==1" class="x-font-color" @click="getCOde()">获取验证码</span>
            <span v-else-if="isCode==2" class="x-font-color" @click="getCOde()">重新获取验证码</span>
            <van-count-down v-else-if="isCode==3" ref="countDown" :time="time" format="ss 秒" :auto-start="false" @finish="finish" />
          </template>
        </van-field>
      </div>
      <div class="x-input-no x-bottom-15">
        <van-field v-model.trim="form.code" type="number" placeholder="请输入短信验证码" :rules="[{ required: true, message: '' }]"/>
      </div>
      <div class="x-input-no x-bottom-15">
        <van-field class="hidden" v-model.trim="form.password" placeholder="请设置6-20位登录密码"
                   :rules="[{ required: true, message: '' },{ pattern, message: '请输入6-20位数字或英文密码' }]"/>
      </div>
      <div class="x-input-no x-bottom-15">
        <van-field class="hidden" v-model.trim="form.verifyPassword" placeholder="请再次输入密码" :rules="[{ required: true, message: '' },{ pattern, message: '请输入6-20位数字或英文密码' }]"/>
      </div>
      <div v-if="isRegister==1"  class="x-flex-between">
        <van-button block class="x-btn-default m-btn" @click="backSubmit" native-type="button">
          <van-icon name="arrow-left" />  上一步
        </van-button>
        <van-button block class="x-btn-log m-btn" native-type="submit">
          立即注册
        </van-button>
      </div>
      <div v-if="isRegister==2" class="x-flex-center">
        <van-button v-if="upIdcard!=1&&upImage!=1" block class="x-btn-log m-btn" native-type="submit">
          提交申请
        </van-button>
        <van-button v-if="upIdcard==1||upImage==1" block class="x-btn-log m-btn" native-type="submit">
          下一步 <van-icon name="arrow" />
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>

  export default {
    components: {},
    props:{
      isRegister:{
        type:Number,
        default:0
      }
    },
    data () {
      return {
        form:{
          phone:'',
          code:'',
          password:'',
          verifyPassword:'',
        },
        idCardNum:'',
        isCode:1,
        time:60000,
        pattern: /^[0-9a-zA-Z]{6,20}/,
        upIdcard:'',
        upImage:'',
      }
    },
    created () {
      if(this.isRegister==2){
        this.getTenant()
      }
    },
    methods: {
      onSubmit(){
        let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if(!reg.test(this.form.phone)){
          this.utils.toastNone('手机号格式不正确！')
          return
        }
        if(this.form.password===this.form.verifyPassword){
          if(this.isRegister==2){
            this.goTo()
          }else {
            this.$emit('submit')
          }
        }else {
          this.utils.toastNone('两次密码输入不一致，请重新输入！')
        }
      },
      backSubmit(){
        this.$emit('isOK',1)
      },
      getCOde(){
        let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if(!this.form.phone){
          this.utils.toastNone('手机号不能为空！')
          return
        }
        if(!reg.test(this.form.phone)){
          this.utils.toastNone('手机号格式不正确！')
          return
        }
        this.http.postRequest({
          url:'app/userInfo/getSignCode',
          msg:{phone:this.form.phone},
          success:(res)=>{
            if(res.code==200){
              this.utils.toastNone(res.msg)
              this.time = 60000
              this.isCode = 3
              this.$nextTick(()=>{
                this.$refs.countDown.start();
              })
            }
          }
        })
      },
      finish(){
        this.$refs.countDown.reset();
        this.isCode = 2
      },
      getTenant(){
        this.http.getRequest({
          url:'app/userInfo/tenantNoLogin',
          msg:{},
          success:(res)=>{
            this.upIdcard = res.data.upIdcard
            this.upImage = res.data.upImage
          }
        })
      },
      goTo(){
        this.http.postRequest({
          url:'app/userInfo/applyCheckInsertTwo',
          msg:{...this.form,idCardNum:this.idCardNum},
          success:(res)=>{
            if(res.code==200){
              if(this.upIdcard!=1&&this.upImage!=1){
                this.$emit('submit')
              } else {
                this.$router.push({
                  path:'/appCard',
                  query:{
                    idCardNum:this.idCardNum
                  }
                })
              }
            }
          }
        })
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .m-box{
    .m-btn{
      width: 156px;
      margin-top: 48px;
    }
    .hidden{
      /deep/.van-field__value {
        -webkit-text-security: disc;
        text-security: disc;
      }
    }
  }
</style>

